import { render, staticRenderFns } from "./StructureModal.vue?vue&type=template&id=356f05c9"
import script from "./StructureModal.vue?vue&type=script&lang=js"
export * from "./StructureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports